
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    content: {
      type: [String, Number, Boolean, null, Object, Array, undefined] as any,
      default: ''
    }
  }
})
